import { render, staticRenderFns } from "./IpLimit.vue?vue&type=template&id=1e4ae6ca&"
import script from "./IpLimit.vue?vue&type=script&lang=js&"
export * from "./IpLimit.vue?vue&type=script&lang=js&"
import style0 from "./IpLimit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports